import { store } from "../store";
import { authChange } from "../store/Auth";
import { HttpHandler } from "./http-handler";
import { HttpRequest as BaseHttpRequest } from "./http-request";
import CurrencyFormat from "currency-formatter";

const percent = /^(100(\.0{0,2}?)?$|([1-9]|[1-9][0-9])(\.\d{1,2})?)$/gm;
const percentZero = /^(0*100{1,1}\.?((?<=\.)0*)?%?$)|(^0*\d{0,2}\.?((?<=\.)\d*)?%?)$/gm;

const currencyRegex = /(?=.*?\d)^\$?(([1-9]\d{0,2}(,\d{3})*)|\d+)?(\.\d{1,2})?$/;
const dayRegex = /^[0-9\b]{1,3}$/gm;
const registerNumber = /^[А-Яа-я|Үү|Өө|Ёё]{2}[0-9]{8}$/;

// const numberRegex = /^[0-9\b]$/gm;
const numberRegex = /[0-9]/gm;
const bankAccountRegex = /^\+?\d{10,15}$/;
const regNumber = /^[0-9]{7}$/;

// const navigate = useNavigate();

export class HttpRequest extends BaseHttpRequest {
  // navigate = useNavigate();
  store = store;
  errorHandler = (statusCode: number, error: HttpHandler): HttpHandler => {
    if (statusCode === 401) {
      store.dispatch(authChange());
      // window.location.assign("/auth/login1");
    }

    throw error;
  };
}

const tugrug = (value: number) =>
  CurrencyFormat.format(value, {
    code: "MNT",
    format: "%v %s",
    thousand: "'",
    decimal: ".",
  });

export { percent, currencyRegex, dayRegex, registerNumber, numberRegex, bankAccountRegex, regNumber, tugrug, percentZero };
